import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  HostListener
} from '@angular/core';
import { luminanciaRelativaHex, obtenerColorReporte } from '../../config/colores-visitas.config';
import { formatChileanNumber } from '../../utils/numeros.util';
import {
  ColumnaTablaFullscreen,
  construirTablaDistribucion
} from '../../utils/grafico-fullscreen-tabla.util';
import {
  AnclaDomGrafico,
  cerrarOverlayPantallaCompleta,
  sincronizarOverlayPantallaCompleta
} from '../../utils/grafico-fullscreen.util';

type Chart = any;

@Component({
  selector: 'app-grafico-dona',
  template: `
    <div #pantallaCompletaRoot class="grafico-pantalla-completa-root" [class.grafico-overlay-activo]="modalAbierto">
    <div class="tarjeta-grafico shadow-premium">
      <div class="header-grafico">
        <div class="titulos">
          <h3>{{ titulo }}</h3>
          <p *ngIf="subtitulo">{{ subtitulo }}</p>
        </div>
        <div class="acciones-header">
          <ion-icon *ngIf="informacion" name="information-circle-outline" [id]="idUnico" class="icon-info"></ion-icon>
          <ion-popover *ngIf="informacion" [trigger]="idUnico"
            triggerAction="click" reference="trigger"
            [side]="modalAbierto ? 'bottom' : 'top'" alignment="center"
            [cssClass]="modalAbierto ? 'popover-grafico-fullscreen' : undefined"
            [showBackdrop]="modalAbierto" [backdropDismiss]="modalAbierto ? true : undefined">
            <ng-template>
              <div class="popover-informacion">
                <p>{{ informacion }}</p>
              </div>
            </ng-template>
          </ion-popover>
          <ion-button *ngIf="!modalAbierto" class="boton-pantalla-completa" fill="clear" size="small"
            [disabled]="cargando || datos.length === 0"
            (click)="abrirPantallaCompleta()"
            aria-label="Ver gráfico en pantalla completa">
            <ion-icon name="expand-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button *ngIf="modalAbierto" class="btn-cerrar-fullscreen" fill="clear" size="small"
            (click)="cerrarPantallaCompleta()" aria-label="Cerrar pantalla completa">
            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div class="cuerpo-grafico">
        <div *ngIf="cargando" class="cargando-container">
          <ion-spinner name="crescent"></ion-spinner>
          <p>Cargando datos...</p>
        </div>

        <div [hidden]="cargando || datos.length === 0" class="canvas-wrapper">
          <div class="grafico-fullscreen-body" [class.grafico-fullscreen-body--activo]="modalAbierto">
            <div class="grafico-canvas-host" [class.grafico-fullscreen-contenido]="modalAbierto">
              <canvas #graficoCanvas></canvas>
            </div>
            <app-grafico-fullscreen-tabla *ngIf="modalAbierto"
              [columnas]="columnasTablaFullscreen"
              [filas]="filasTablaFullscreen">
            </app-grafico-fullscreen-tabla>
          </div>
        </div>

        <div *ngIf="!cargando && datos.length === 0" class="sin-datos">
          <ion-icon name="pie-chart-outline"></ion-icon>
          <p>No hay datos disponibles para mostrar</p>
        </div>
      </div>
    </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      height: 100%;
    }
    .grafico-pantalla-completa-root {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      height: 100%;
      min-height: 0;
      width: 100%;
    }
    .tarjeta-grafico {
      background: var(--ion-card-background, var(--ion-item-background, #ffffff));
      border: 1px solid var(--ion-color-light-shade);
      border-radius: 12px;
      padding: 20px;
      flex: 1 1 auto;
      height: 100%;
      min-height: 0;
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }
    .header-grafico {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
      margin-bottom: 20px;
      flex-shrink: 0;
    }
    .titulos {
      flex: 1;
      min-width: 0;
    }
    .titulos h3 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 700;
      color: var(--ion-color-dark);
    }
    .titulos p {
      margin: 4px 0 0;
      font-size: 0.85rem;
      color: var(--ion-color-medium);
    }
    .acciones-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;
      margin-left: auto;
      flex-shrink: 0;
    }
    .icon-info {
      font-size: 1.2rem;
      color: var(--ion-color-primary);
      cursor: pointer;
    }
    .boton-pantalla-completa,
    .btn-cerrar-fullscreen {
      --padding-start: 4px;
      --padding-end: 4px;
      --color: var(--ion-color-primary);
      margin: 0;
      height: 32px;
      width: 32px;
    }
    .boton-pantalla-completa ion-icon,
    .btn-cerrar-fullscreen ion-icon {
      font-size: 1.2rem;
    }
    .cuerpo-grafico {
      flex: 1;
      position: relative;
      min-height: 250px;
    }
    .canvas-wrapper {
      position: absolute;
      top: 0; left: 0; bottom: 0; right: 0;
      width: 100%;
      height: 100%;
    }
    .grafico-canvas-host {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .grafico-fullscreen-body {
      display: flex;
      flex: 1 1 auto;
      min-height: 0;
      width: 100%;
      height: 100%;
    }

    .grafico-fullscreen-body--activo {
      width: 100%;
      height: 100%;
    }

    .grafico-fullscreen-body--activo .grafico-canvas-host.grafico-fullscreen-contenido {
      min-height: 0;
    }

    .grafico-fullscreen-body--activo .grafico-canvas-host.grafico-fullscreen-contenido canvas {
      position: absolute;
      inset: 0;
      height: 100% !important;
    }
    .cargando-container, .sin-datos {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: var(--ion-color-medium);
    }
    .sin-datos ion-icon {
      font-size: 3rem;
      margin-bottom: 10px;
      opacity: 0.5;
    }
    .texto-popover {
      font-size: 0.9rem;
      line-height: 1.4;
      margin: 0;
      color: var(--ion-color-dark);
    }
  `],
  standalone: false
})
export class GraficoDonaComponent implements AfterViewChecked, OnChanges, OnDestroy {
  private static contadorId = 0;
  public idUnico: string;

  @ViewChild('graficoCanvas', { static: false }) graficoCanvasRef!: ElementRef;
  @ViewChild('pantallaCompletaRoot', { static: false }) pantallaCompletaRoot!: ElementRef<HTMLElement>;

  @Input() titulo: string = '';
  @Input() subtitulo: string = '';
  @Input() datos: { label: string; value: number }[] = [];
  @Input() cargando: boolean = false;
  @Input() informacion: string = '';

  modalAbierto = false;

  columnasTablaFullscreen: ColumnaTablaFullscreen[] = [];
  filasTablaFullscreen: Record<string, string | number>[] = [];

  private grafico: Chart | null = null;
  private graficoCreado = false;
  private creandoGrafico = false;
  private chartJsCargado = false;
  private ChartClass: any = null;

  private resizeObserver: ResizeObserver | null = null;
  private resizeFrameId: number | null = null;
  private ultimoTamanoContenedor: { w: number; h: number } | null = null;
  private anclaDomOverlay: AnclaDomGrafico | null = null;

  constructor() {
    this.idUnico = `info-dona-${GraficoDonaComponent.contadorId++}`;
  }

  private actualizarTablaFullscreen(): void {
    const tabla = construirTablaDistribucion(this.datos);
    this.columnasTablaFullscreen = tabla.columnas;
    this.filasTablaFullscreen = tabla.filas;
  }

  ngAfterViewChecked(): void {
    if (this.modalAbierto) {
      this.anclaDomOverlay = sincronizarOverlayPantallaCompleta(
        this.pantallaCompletaRoot?.nativeElement,
        true,
        this.anclaDomOverlay
      );
    }

    if (
      !this.graficoCreado &&
      !this.creandoGrafico &&
      this.graficoCanvasRef &&
      this.datos.length > 0 &&
      !this.cargando
    ) {
      this.creandoGrafico = true;
      void this.crearGrafico()
        .then(() => {
          this.graficoCreado = true;
        })
        .catch(console.error)
        .finally(() => {
          this.creandoGrafico = false;
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cargando'] && this.cargando) {
      this.graficoCreado = false;
      this.destruirGrafico();
      return;
    }

    if (changes['datos']) {
      this.actualizarTablaFullscreen();
      if (this.datos.length === 0) {
        this.graficoCreado = false;
        this.destruirGrafico();
        return;
      }

      if (this.grafico) {
        this.actualizarGrafico().catch(console.error);
      } else if (this.graficoCreado) {
        this.graficoCreado = false;
      }
    }
  }

  ngOnDestroy(): void {
    this.destruirGrafico();
    if (this.modalAbierto) {
      this.cerrarPantallaCompleta();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.modalAbierto) {
      this.cerrarPantallaCompleta();
    }
  }

  abrirPantallaCompleta(): void {
    if (this.cargando || this.datos.length === 0 || this.modalAbierto) {
      return;
    }
    this.actualizarTablaFullscreen();
    this.modalAbierto = true;
    this.programarResizeGrafico(true);
  }

  cerrarPantallaCompleta(): void {
    if (!this.modalAbierto) {
      return;
    }
    this.modalAbierto = false;
    cerrarOverlayPantallaCompleta(this.pantallaCompletaRoot?.nativeElement, this.anclaDomOverlay);
    this.anclaDomOverlay = null;
    this.programarResizeGrafico(true);
  }

  private coloresEtiquetaSobreFondo(hexFondo: string): { color: string; textStrokeColor: string } {
    const L = luminanciaRelativaHex(hexFondo || '#6b7280');
    const umbral = 0.45;
    if (L < umbral) {
      return { color: '#ffffff', textStrokeColor: 'rgba(0, 0, 0, 0.35)' };
    }
    return { color: '#1a1a1a', textStrokeColor: 'rgba(255, 255, 255, 0.85)' };
  }

  private async cargarChartJs(): Promise<void> {
    if (this.chartJsCargado && this.ChartClass) return;
    const [{ Chart, registerables }, ChartDataLabels] = await Promise.all([
      import('chart.js'),
      import('chartjs-plugin-datalabels')
    ]);
    Chart.register(...registerables, ChartDataLabels.default);
    this.ChartClass = Chart;
    this.chartJsCargado = true;
  }

  private esModoOscuro(): boolean {
    return document.documentElement.classList.contains('dark') ||
      document.documentElement.classList.contains('ion-palette-dark');
  }

  private construirConfiguracionGrafico() {
    const labels = this.datos.map(d => d.label);
    const values = this.datos.map(d => d.value);
    const backgroundColors = this.datos.map(d => obtenerColorReporte(d.label));
    const isDark = this.esModoOscuro();
    const secondaryTextColor = isDark ? 'rgba(255, 255, 255, 0.7)' : '#666666';

    return {
      type: 'doughnut' as const,
      data: {
        labels,
        datasets: [{
          data: values,
          backgroundColor: backgroundColors,
          borderWidth: isDark ? 1 : 0,
          borderColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'transparent'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%',
        plugins: {
          legend: {
            display: true,
            position: 'bottom' as const,
            labels: {
              usePointStyle: true,
              pointStyle: 'circle' as const,
              padding: 15,
              color: secondaryTextColor,
              font: { size: 11 }
            }
          },
          datalabels: {
            display: (context: any) => context.dataset.data[context.dataIndex] > 0,
            color: (context: any) => {
              const bg = context.dataset.backgroundColor[context.dataIndex];
              return this.coloresEtiquetaSobreFondo(bg).color;
            },
            textStrokeColor: (context: any) => {
              const bg = context.dataset.backgroundColor[context.dataIndex];
              return this.coloresEtiquetaSobreFondo(bg).textStrokeColor;
            },
            textStrokeWidth: 1.5,
            font: { weight: 'bold' as const, size: 12 },
            formatter: (value: number, context: any) => {
              const dataset = context.dataset.data as number[];
              const total = dataset.reduce((a, b) => a + b, 0);
              return total > 0 ? `${formatChileanNumber((value / total) * 100, 1)}%` : '';
            }
          }
        }
      }
    };
  }

  private async crearGrafico(): Promise<void> {
    const ctx = this.graficoCanvasRef?.nativeElement?.getContext('2d');
    if (!ctx) return;

    await this.cargarChartJs();
    if (!this.ChartClass) return;

    this.destruirGrafico();

    const config = this.construirConfiguracionGrafico();
    const chart = new this.ChartClass(ctx, config);
    this.grafico = chart;

    const canvas = this.graficoCanvasRef.nativeElement;
    const contenedor = canvas.closest('.canvas-wrapper') as HTMLElement | null;
    const elementoObservado = contenedor ?? canvas.parentElement;

    if (elementoObservado && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver?.disconnect();

      this.resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;
        const { width, height } = entry.contentRect;
        const prev = this.ultimoTamanoContenedor;
        if (prev && Math.abs(prev.w - width) < 2 && Math.abs(prev.h - height) < 2) {
          return;
        }
        this.ultimoTamanoContenedor = { w: width, h: height };
        this.programarResizeGrafico();
      });
      this.resizeObserver.observe(elementoObservado);
    }
  }

  private async actualizarGrafico(): Promise<void> {
    if (!this.grafico) {
      await this.crearGrafico();
      this.graficoCreado = true;
      return;
    }

    if (this.datos.length === 0) {
      this.graficoCreado = false;
      this.destruirGrafico();
      return;
    }

    this.grafico.data.labels = this.datos.map(d => d.label);
    this.grafico.data.datasets[0].data = this.datos.map(d => d.value);
    this.grafico.data.datasets[0].backgroundColor = this.datos.map(d => obtenerColorReporte(d.label));
    this.grafico.update('none');
    this.programarResizeGrafico();
  }

  private programarResizeGrafico(reiniciarCacheTamano = false): void {
    if (reiniciarCacheTamano) {
      this.ultimoTamanoContenedor = null;
    }

    if (this.resizeFrameId !== null) {
      cancelAnimationFrame(this.resizeFrameId);
    }
    this.resizeFrameId = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.resizeFrameId = null;
        this.grafico?.resize();
      });
    });
  }

  private destruirGrafico(): void {
    if (this.resizeFrameId !== null) {
      cancelAnimationFrame(this.resizeFrameId);
      this.resizeFrameId = null;
    }
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    this.ultimoTamanoContenedor = null;
    if (this.grafico) {
      this.grafico.destroy();
      this.grafico = null;
    }
  }
}
